import { render, staticRenderFns } from "./editInfo.vue?vue&type=template&id=5040ca98&scoped=true&"
import script from "./editInfo.vue?vue&type=script&lang=js&"
export * from "./editInfo.vue?vue&type=script&lang=js&"
import style0 from "./editInfo.vue?vue&type=style&index=0&id=5040ca98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5040ca98",
  null
  
)

export default component.exports